<template>
    <div>
        <p>Exportiert sämtliche Transaktionen in eine CSV-Datei</p>
        <p></p>
        <div class="col-6">
            <div class="custom-control custom-switch">
                <input
                    class="custom-control-input"
                    type="checkbox"
                    id="ignoreReverts"
                    v-model="ignoreReverts"
                >
                <label class="custom-control-label" for="ignoreReverts">Stornos und stornierte Buchungen ignorieren</label>
            </div>
        </div>
        <div class="col-6">
            <div class="custom-control custom-switch">
                <input
                    class="custom-control-input"
                    type="checkbox"
                    id="inOutMethod"
                    v-model="inOutMethod"
                >
                <label class="custom-control-label" for="inOutMethod">Ein- und Ausgabeverfahren</label>
            </div>
        </div>
        <p></p>

        <div class="p-0">
            <a class="btn btn-primary"
               :class="{ 'loading-button': loading }"
               @click="exportCsv($event)"
               href="#"
               role="button">
                <span :class="{ 'invisible-text': loading }">Daten herunterladen</span>
            </a>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ExportAllTransactions',
    data() {
        return {
            ignoreReverts: false,
            inOutMethod: false,
            loading: false
        }
    },
    methods: {
        exportCsv(event) {
            let credentials = JSON.parse(localStorage.getItem('credentials'))
            event.preventDefault();
            this.loading = true;
            axios({
                url: process.env.VUE_APP_ROOT_API + '/export/all_entries',
                method: 'GET',
                auth: credentials,
                responseType: 'blob',
                params: {
                    ignoreReverts: this.ignoreReverts,
                    inOutMethod: this.inOutMethod
                }
            }).then(response => {
                this.loading = false;
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                const dateStr = new Date().toISOString().split('T')[0];
                link.setAttribute('download', `export_${dateStr}.csv`);
                document.body.appendChild(link);
                link.click();
            }).catch(error => {
                console.error('Error exporting CSV:', error);
                let msg = {
                    type: 'ERROR',
                    message: 'Fehler beim Exportieren der CSV-Datei'
                }
                this.$store.commit('add_message', msg);
                this.loading = false;
            });
        }
    }
}
</script>


<style scoped>
.loading-button {
    position: relative;
    pointer-events: none;
    opacity: 0.6;
}

.loading-button::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1rem;
    height: 1rem;
    border: 2px solid #fff;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
    transform: translate(-50%, -50%);
}

@keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
}

.invisible-text {
    visibility: hidden;
}

.custom-switch {
    padding-left: 2.25rem;
    padding-bottom: 1rem;
}

.custom-control-input {
    padding-bottom: 0.1rem;
    display: flex;
    align-items: center;
}

.custom-control-label {
    padding-top: 0.1rem;
    padding-left: 1.75rem;
}

.custom-switch .custom-control-label::before {
    left: -2.25rem;
    height: 1.25rem;
    width: 2.25rem;
    pointer-events: all;
    border-radius: 1rem;
}

.custom-switch .custom-control-label::after {
    top: calc(0.25rem + 2px);
    left: calc(-2.25rem + 2px);
    width: calc(1.25rem - 4px);
    height: calc(1.25rem - 4px);
    background-color: #adb5bd;
    border-radius: 0.75rem;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;
    transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
    .custom-switch .custom-control-label::after {
        transition: none;
    }
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    background-color: #fff;
    -webkit-transform: translateX(1.0rem);
    transform: translateX(1.0rem);
}
</style>